import {
  nameSpace,
  activityUserConstants,
} from "../constants/activityLog.constants";
import { activityLogService } from "../services/activityLog.service";

export const getAllActivityUsers = (requestParams) => {
  return async (dispatch) => {
    dispatch(request(requestParams));
    try {
      const response = await activityLogService.getAllUsers(requestParams);
      response && dispatch(success(response));
    } catch (error) {
      dispatch(failure(error));
    }
  };

  function request(request) {
    return { type: activityUserConstants[`GET_${nameSpace}_REQUEST`], request };
  }
  function success(response) {
    return {
      type: activityUserConstants[`GET_${nameSpace}_SUCCESS`],
      response,
    };
  }
  function failure(error) {
    return { type: activityUserConstants[`GET_${nameSpace}_FAILURE`], error };
  }
};
